import Vue from "vue";
import {customDialogsImport} from "@/utils";

let modal = customDialogsImport("modal");
let modalLoader = customDialogsImport("modalLoader");
let modalFullLoader = customDialogsImport("modalFullLoader");
let modalAsk = customDialogsImport("modalAsk");
let modalYesNo = customDialogsImport("modalYesNo");
let modalAssign = customDialogsImport("modalAssign");
let modalVariant = customDialogsImport("modalVariant");
let modalDclass = customDialogsImport("modalDClass");
let modalRF = customDialogsImport("modalRenderfarm");
let modalDivider = customDialogsImport("modalDivider");
let modalComponent = customDialogsImport("modalComponent");
import {store} from "@/_eng/store/store";

let Imodal;
let ImodalComponent;
let ImodalLoader;
let ImodalFullLoader;
let ImodalAsk;
let ImodalYesNo;
let ImodalAssign;
let ImodalVariant;
let ImodalDclass;
let ImodalRF;
let ImodalDivider;

const NextModals = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!Imodal) {
            const constructor = Vue.extend(modal);
            Imodal = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(Imodal.$el);

        Vue.nextTick(() => {
            Imodal.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.loader = options => {
    // Build instance
    if (!ImodalLoader) {
        const constructor = Vue.extend(modalLoader);
        ImodalLoader = new constructor({
            el: document.createElement("div"),
            store: store
        });
    }

    document.body.appendChild(ImodalLoader.$el);

    Vue.nextTick(() => {
        if (options) ImodalLoader.open(options);
    });
    return ImodalLoader;
};

NextModals.component = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalComponent) {
            const constructor = Vue.extend(modalComponent);
            ImodalComponent = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalComponent.$el);

        Vue.nextTick(() => {
            ImodalComponent.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.fullLoader = options => {
    // Build instance
    if (!ImodalFullLoader) {
        const constructor = Vue.extend(modalFullLoader);
        ImodalFullLoader = new constructor({
            el: document.createElement("div"),
            store: store
        });
    }

    document.body.appendChild(ImodalFullLoader.$el);

    Vue.nextTick(() => {
        if (options) ImodalFullLoader.open(options);
    });
    return ImodalFullLoader;
};

NextModals.ask = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalAsk) {
            const constructor = Vue.extend(modalAsk);
            ImodalAsk = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalAsk.$el);

        Vue.nextTick(() => {
            ImodalAsk.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.yesNo = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalYesNo) {
            const constructor = Vue.extend(modalYesNo);
            ImodalYesNo = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalYesNo.$el);

        Vue.nextTick(() => {
            ImodalYesNo.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.assignPrj = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalAssign) {
            const constructor = Vue.extend(modalAssign);
            ImodalAssign = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalAssign.$el);

        Vue.nextTick(() => {
            ImodalAssign.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.popVariant = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalVariant) {
            const constructor = Vue.extend(modalVariant);
            ImodalVariant = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalVariant.$el);

        Vue.nextTick(() => {
            ImodalVariant.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.popDclass = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalDclass) {
            const constructor = Vue.extend(modalDclass);
            ImodalDclass = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalDclass.$el);

        Vue.nextTick(() => {
            ImodalDclass.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.launchRender = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalRF) {
            const constructor = Vue.extend(modalRF);
            ImodalRF = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalRF.$el);

        Vue.nextTick(() => {
            ImodalRF.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

NextModals.popDivider = async options => {
    return new Promise((resolve, reject) => {
        // Build instance
        if (!ImodalDivider) {
            const constructor = Vue.extend(modalDivider);
            ImodalDivider = new constructor({
                el: document.createElement("div"),
                store: store
            });
        }

        document.body.appendChild(ImodalDivider.$el);

        Vue.nextTick(() => {
            ImodalDivider.open(options).$once("close", (mode, data) => {
                if (mode === 1) resolve(data);
                else reject(mode);
            });
        });
    });
};

export default NextModals;

export {
    Imodal,
    ImodalComponent,
    ImodalLoader,
    ImodalFullLoader,
    ImodalAsk,
    ImodalYesNo,
    ImodalAssign,
    ImodalVariant,
    ImodalDclass,
    ImodalRF,
    ImodalDivider
};



// WEBPACK FOOTER //
// ./src/app/dialogs/index.js